import React, { lazy } from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { useScrollAnimation } from './useScrollAnimation';
const cities = ['Ahwatukee Foothills', 'Casa Grande', 'Chandler', 'Gilbert', 'Litchfield Park', 'Maricopa', 'Mesa', 'Phoenix', 'Queen Creek', 'Scottsdale', 'Sun Lakes', 'Tempe'];
export function ServiceAreaSection() {
  const ref = useScrollAnimation();
  return <section id="locations" className="w-full py-20 px-4" style={{
    backgroundColor: '#ffffff'
  }} data-id="element-186">
      <div className="max-w-7xl mx-auto" ref={ref} data-id="element-187">
        {/* Heading */}
        <div className="text-center mb-12 scroll-animate" data-id="element-188">
          <h2 className="font-bold mb-4" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(26px, 4vw, 40px)',
          color: '#0283C7',
          fontWeight: 800
        }} data-id="element-189">
            Proudly Serving the Valley
          </h2>
        </div>

        {/* Map visual */}
        <div className="w-full mb-12 overflow-hidden scroll-animate" style={{
        borderRadius: '16px',
        height: '320px',
        backgroundColor: '#E8F4FD',
        position: 'relative'
      }} data-id="element-190">
          <iframe title="Blue Cactus Power Washing Service Area" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d847742.5!2d-112.074!3d33.448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b12ed50a179cb%3A0x8c69c7f8354a1bac!2sPhoenix%2C%20AZ!5e0!3m2!1sen!2sus!4v1234567890" width="100%" height="100%" style={{
          border: 0,
          filter: 'hue-rotate(180deg) saturate(0.6) brightness(1.1)'
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-191" />
          <div className="absolute top-4 left-1/2 -translate-x-1/2" data-id="element-192">
            <div className="px-4 py-2 rounded-full font-semibold text-white text-sm flex items-center gap-2" style={{
            backgroundColor: '#0283C7',
            boxShadow: '0 4px 16px rgba(2,131,199,0.4)'
          }} data-id="element-193">
              <MapPinIcon className="h-4 w-4" data-id="element-194" />
              Phoenix Metro Area
            </div>
          </div>
        </div>

        {/* City Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mb-12 scroll-animate" style={{
        transitionDelay: '0.1s'
      }} data-id="element-195">
          {cities.map(city => <a key={city} href={`#${city.toLowerCase().replace(/\s+/g, '-')}`} className="font-medium py-2 px-3 text-center transition-colors hover:underline" style={{
          color: '#0283C7',
          fontFamily: 'Inter, sans-serif',
          fontSize: '15px'
        }} data-id="element-196">
              {city}
            </a>)}
        </div>

        {/* CTA */}
        <div className="text-center scroll-animate" style={{
        transitionDelay: '0.2s'
      }} data-id="element-197">
          <p className="mb-3" style={{
          color: '#374151',
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px'
        }} data-id="element-198">
            Not sure if we cover your area? Call us!
          </p>
          <a href="tel:4805998442" className="font-bold inline-flex items-center gap-2 py-3 px-6 rounded-lg text-white transition-all hover:scale-[1.03]" style={{
          backgroundColor: '#0283C7',
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px',
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(2,131,199,0.3)'
        }} data-id="element-199">
            <PhoneIcon className="h-5 w-5" data-id="element-200" />
            (480) 599-8442
          </a>
        </div>
      </div>
    </section>;
}